import { createActions, createReducer } from 'reduxsauce'

import DotacaoService from '../servicos/DotacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaExerciciosInicio: [],
    buscaExerciciosSucesso: ['exercicios', 'jaSelecionado'],
    buscaExerciciosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaExercicios = jaSelecionado => {
    return dispatch => {
        dispatch(Creators.buscaExerciciosInicio())
        let serv = new DotacaoService()
        return serv
            .getExercicios()
            .then(response => dispatch(Creators.buscaExerciciosSucesso(response.data, jaSelecionado)))
            .catch(error => dispatch(Creators.buscaExerciciosErro(error)))
    }
}

const buscaExerciciosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaExerciciosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaExerciciosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.exercicios, carregando: false, selecionado: action.jaSelecionado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EXERCICIOS_INICIO]: buscaExerciciosInicio,
    [Types.BUSCA_EXERCICIOS_ERRO]: buscaExerciciosErro,
    [Types.BUSCA_EXERCICIOS_SUCESSO]: buscaExerciciosSucesso,
})
